import { Toast } from "../../dialog/toast";
import { ChipsideComponent } from "../chipside-component";

export class CodeBlock extends ChipsideComponent {
	static observedAttributes = ["autowrap"];

	constructor() {
		super();

		this.language = this.getAttribute("language");
		this.autowrap = this.hasAttribute("autowrap");
	}

	parsedCallback() {
		const codeElement = this.querySelector("code");

		if (codeElement) {
			if (!this.autowrap) {
				codeElement.trimBreaks();
			}

			if (this.language) {
				codeElement.classList.add(`language-${this.language}`);
			}
		}
		this.querySelector("code")?.trimBreaks();

		this.appendChild(
			document.createElementWithContents("pre", this.childNodes)
		);

		const copyButton = document.createElementWithContents("chip-button", null, {
			buttonStyle: "icon",
			icon: "fal fa-copy",
			variation: "body",
			className: "btn--copy-code",
			tooltip: "Copy code"
		});

		copyButton.onclick = () => writeClipboardText(codeElement.textContent).then(() => Toast.ShowSuccess("Copied to clipboard"));

		this.appendChild(copyButton);

		CodeHighlight.highlightElement(codeElement);
	}
}